import React from 'react';
import GradientWrapper from './GradientWrapper';
interface GradientPillButtonProps {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}
const GradientPillButton: React.FC<GradientPillButtonProps> = ({
  children,
  onClick,
  disabled = false,
  className = ''
}) => {
  return <GradientWrapper radius="100px" paddingPx={1} data-id="element-1251">
      <button onClick={onClick} disabled={disabled} className={`bg-white px-4 py-2 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed w-full h-full flex items-center justify-center ${className}`} style={{
      borderRadius: 'calc(100px - 1px)'
    }} data-id="element-1252">
        {children}
      </button>
    </GradientWrapper>;
};
export default GradientPillButton;